import {
  requireSDK,
  appendReferrerID,
  tokenize,
  assetFromRef,
  isAssetRef,
  transposeString,
  b64EncodeString,
} from '../utils/utils';
import { isChromeIOS, isMobile } from '../utils/browser';
import { AnalyticsEvents as PUB } from '../../common/config/api.js';
import enums from '../../common/config/enums';

/**
 * Privacy Management Note: Sharing appends a UUID of the user to the links during sharing to track the
 * user through social sharing.  If the user does not consent to tracking/analytics cookies, the appendReferrerID
 * function will no longer append the UUID.
 */

// Accessed as: NGX.App.api.facebookShare()
export function facebookShare(config) {
  requireSDK(log.getDebugLevel() ? 'fbdebug' : 'fb', function() {
    var fbDisplay;

    if (isChromeIOS()) {
      fbDisplay = 'touch';
    }
    if (isMobile()) {
      fbDisplay = 'popup';
    }

    // This callback is run after facebook sdk is finished loading.
    var _cb = function() {
      var uiConfig = {
        app_id:  NGX.context.fb.app.id,
        method:  'share',
        display: fbDisplay || 'popup',
        href:    appendReferrerID({
          // Add referer ID
          link:   config.link,
          c_name: 'ngx',
        }),
        redirect_uri: config.link
      };

      // TODO: re-examine actionLink, actionText and noAction; they're very old concepts and can probably be very carefully removed entirely from the codebase
      if (
        config.noAction === true ||
        (config.actionLink && config.actionLink !== '' && config.actionText && config.actionText != '')
      ) {
        uiConfig.actions = {
          name: config.actionText,
          link: appendReferrerID({
            link:   config.link ? config.link : config.actionlink,
            c_name: 'ngx',
          }),
        };
      }

      // Trigger the dialog - no callback
      FB.ui(uiConfig);

      // hotfix/WYN-5326
      // Facebook's SDK appears to be positioning dialogs incorrectly. This centers the dialog
      // after it has loaded
      if (uiConfig.display === 'dialog') {
        function center(el) {
          el.css({
            position: 'absolute',
            top:      ($(window).height() - el.outerHeight()) / 2 + $(window).scrollTop() + 'px',
            left:     ($(window).width() - el.outerWidth()) / 2 + $(window).scrollLeft() + 'px',
          });
        }

        var loadingEl = $('.fb_dialog.fb_dialog_advanced:has(.dialog_footer)');
        center(loadingEl);

        $('#fb-root iframe').on('load', function(e) {
          // Fixes race condition between facebook sizing and the code below
          setTimeout(function() {
            var dialogEl = $('#fb-root .FB_UI_Dialog').parents('.fb_dialog.fb_dialog_advanced');
            center(dialogEl);
          }, 250);
        });
      }
    };

    setTimeout(() => {
      if (NGX.App.state.hasOwnProperty('fbLoaded')) {
        _cb();
      } else {
        //NGX.App.Events.once('fb:ready',_cb);
      }
    }, 100);
  });
} // END Facebook share

export default (function(w, doc, undefined) {
  // spawn the popup window
  var openWindow = function(url, obj) {
      if (url) {
        // Allow forced http mode (for Weibo)
        if (url.indexOf('http:') == -1) url = '//' + url;

        if (obj) {
          url += '?' + $.param(obj);
        }
        w.open(url, '_blank', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
      }
      return false;
    },
    // Integration API needs identical urls passed to openWindow.
    buildLinkURL = function(url, params) {
      if (!url || !params) {
        return '';
      }
      return (url.indexOf('http:') === -1 ? '//' + url : url) + '?' + $.param(params);
    },
    // wrapped tokenize method
    tokenizeMe = function(input, obj) {
      return tokenize(input, obj || NGX.App.config.extendedProperties);
    },
    // TODO: link refs were never fully fleshed out, so this is a quick implementation, using 'ctx:smarturl' as the link ref.
    buildLink = function(link, internal, additionalParams) {
      var arr,
        json,
        linkString,
        qs = '';

      if ('string' === typeof link) {
        arr = link.split(':');

        if (_.isArray(arr)) {
          switch (arr[0]) {
            case 'url':
              arr[1] = arr[1] == 'campaignlink' ? 'smarturl' : arr[1];
            case 'ctx':
              json = NGX.context;
              break;
          }

          linkString = json ? json[arr[1] || 'smarturl'] : link;
          linkString = linkString ? linkString : document.location.href;

          // If smart url.
          if (linkString.indexOf(NGX.context.smarturl) !== -1) {
            // Append .h suffix to smart url to indicate share.
            const suffix = '.h';
            const qsIndex = linkString.indexOf('?');
            if (qsIndex === -1) {
              linkString += suffix;
            } else {
              linkString = linkString.slice(0, qsIndex) + suffix + linkString.slice(qsIndex);
            }

            // Append additional params if available.
            if (additionalParams && Object.keys(additionalParams).length > 0) {
              linkString += qsIndex === -1 ? '?' : '&';
              linkString += Object.keys(additionalParams)
                .map(k => `${k}=${additionalParams[k]}`)
                .join('&');
            }
          }

          return appendReferrerID({
            link:   linkString,
            c_name: 'ngx',
          });
        }
      } else {
        return link + qs;
      }
    },
    buildAdditionalParams = function(data) {
      const params = {};

      // Share params.
      let shareParams = {};

      // Attempt to get title
      if (data.title) {
        shareParams.t = data.title;
      }

      // Attempt to get description
      if (data.description) {
        shareParams.d = data.description;
      }

      // Attempt to get image
      if (data.image) {
        shareParams.i = data.image;
      }

      // Attempt to get redirect url
      if (data.redirectUrl) {
        shareParams.u = data.redirectUrl;
      }

      // Attempt to get Twitter card format.
      if (data.twitterCardFormat) {
        shareParams.c = data.twitterCardFormat;
      }

      // Convert to string.
      shareParams =
        '{' +
        Object.keys(shareParams)
          .map(k => `"${k}":"${shareParams[k].replace(/"/g, '&quot;')}"`)
          .join(',') +
        '}';

      // If we have some shareParams, obfuscate, then base64 encode and store.
      if (Object.keys(shareParams).length > 0) {
        params.s = encodeURIComponent(b64EncodeString(transposeString(shareParams)));
      }

      return params;
    },
    // fb share track is handled in the API method. others do not have proper API methods
    trackShare = function(data) {
      // extract the type of item being shared from its componenttype attribute.
      var getContext = function(c) {
          var el,
            cmp = 'campaign';
          if (!c) {
            // failover to DisplayItem, which may not actually be entirely correct but the non-APIs don't have any proper callabcks yet
            return 'contentitem';
          } else if (c == 'campaign' || c == 'confirmation') {
            return cmp;
          } else {
            el = doc.getElementById(c);
            if (el) {
              // WYN-4077 Decision was made to now track contest entries module content item shares as per the social modules
              // (previously they were tracked as campaign shares...)
              var cmpType = el.getAttribute('data-componenttype');
              if (
                cmpType == 'socialcontentwall' ||
                cmpType == 'socialcontentmosaic' ||
                cmpType == 'socialcontentcarousel' ||
                cmpType == 'entries'
              ) {
                return 'contentitem';
              } else {
                return 'campaign';
              }
            } else {
              return cmp;
            }
          }
        },
        source = NGX.context.isFB ? 'facebook' : 'web';

      // Privacy management: analytics & insights tracking are gated there.
      NGX.Insights.track('share:' + getContext(data.context), { source: source, target: data.target, i: data.id });
    },
    // configured networks
    networks = {
      twitter: {
        post: function(data, overrides) {
          _.extend(data, overrides);
          const url = 'twitter.com/share';

          // Make sure the non Twitter Card version of the link uses the same logic to generate the initial linkUrl value.
          let linkUrl = NGX.App.config.sharing.customLink ? NGX.App.config.sharing.customLink : data.link;
          if (data.context === 'result') {
            linkUrl =
              NGX.App.result && NGX.App.result.link && NGX.App.result.link !== 'ctx:smarturl' ?
                NGX.App.result.link :
                linkUrl;
          }

          let link = buildLink(linkUrl, overrides.linktype == 'internal');

          // Generate a link in specific format to render a Twitter Card within the Tweet.
          const validCardTypes = ['summary', 'summary_large_image'];
          //if (data.card && validCardTypes.indexOf(data.card) !== -1) {
          var pictureData = assetFromRef(data.picture, NGX.context),
            canonSrc = isAssetRef(data.picture) ? pictureData.src : data.picture;

          if (canonSrc) canonSrc = canonSrc.substring(0, 2) == '//' ? 'https:' + canonSrc : canonSrc;

          linkUrl = data.link;
          let redirectUrl = NGX.App.config.sharing.customLink ? NGX.App.config.sharing.customLink : null;
          if (data.context === 'result') {
            linkUrl = NGX.context.smarturl;
            redirectUrl =
              NGX.App.result && NGX.App.result.link && NGX.App.result.link !== 'ctx:smarturl' ?
                NGX.App.result.link :
                redirectUrl;
          }

          const additionalParams = buildAdditionalParams({
            title:             tokenizeMe(data.title, data),
            description:       tokenizeMe(data.message, data),
            image:             canonSrc ? canonSrc : '',
            redirectUrl:       redirectUrl,
            twitterCardFormat: data.card,
          });
          link = buildLink(linkUrl, false, additionalParams);
          //}

          let message = null; //data.message is the default message text and data.echoInputText is the echo input value
          if (data.echoInputText) {
            message = data.echoInputText;
          } else {
            message = data.message;
          }

          const params = {
            url:  link,
            text: tokenizeMe(message, data),
          };
          openWindow(url, params);

          // API
          // Privacy management: analytics & insights tracking are gated there.
          if (data.context === 'campaign') {
            NGX.Analytics.trigger(PUB.ACTION_SHARE_CAMPAIGN_TWITTER);
          } else {
            NGX.Analytics.trigger(PUB.ACTION_SHARE_CONTENT_TWITTER);
          }

          trackShare($.extend({}, data, { target: 'twitter' }));
        },
      },
      google: {
        post: function(data, overrides) {
          _.extend(data, overrides);

          const url = 'plus.google.com/share';
          const params = {
            url: buildLink(data.link, overrides.linktype == 'internal'),
          };
          openWindow(url, params);

          trackShare($.extend({}, data, { target: 'google' }));
        },
      },
      vk: {
        post: function(data, overrides) {
          _.extend(data, overrides);
          var pictureData = assetFromRef(data.picture, NGX.context),
            canonSrc = isAssetRef(data.picture) ? pictureData.src : data.picture;

          const url = 'vk.com/share.php';
          const params = {
            url:         buildLink(data.link, overrides.linktype == 'internal'),
            title:       tokenizeMe(data.title, data),
            description: tokenizeMe(data.message, data),
            image:       canonSrc ? canonSrc : '',
          };
          openWindow(url, params);

          trackShare($.extend({}, data, { target: 'vk' }));
        },
      },
      facebook: {
        post: function(data, overrides) {
          _.extend(data, overrides);

          var pictureData = assetFromRef(data.picture, NGX.context),
            canonSrc = isAssetRef(data.picture) ? pictureData.src : data.picture;

          // Only use sharer.php for FBCDN images
          if (data.linktype == 'external' && canonSrc.indexOf('fbcdn.net') > -1) {
            const url = 'facebook.com/sharer/sharer.php';
            const params = {
              appId:   NGX.context.fb.app.id,
              sdk:     'joey',
              display: 'popup',
              u:       data.link,
            };
            openWindow(url, params);
            // API
            // Privacy management: analytics & insights tracking are gated there.
            if (data.context === 'campaign') {
              NGX.Analytics.trigger(PUB.ACTION_SHARE_CAMPAIGN_FACEBOOK);
            } else {
              NGX.Analytics.trigger(PUB.ACTION_SHARE_CONTENT_FACEBOOK);
            }
          } else {
            if (canonSrc) canonSrc = canonSrc.substring(0, 2) == '//' ? 'https:' + canonSrc : canonSrc;

            let linkUrl = data.link;
            let redirectUrl = NGX.App.config.sharing.customLink ? NGX.App.config.sharing.customLink : null;
            if (data.context === 'result') {
              linkUrl = NGX.context.smarturl;
              redirectUrl =
                NGX.App.result && NGX.App.result.link && NGX.App.result.link !== 'ctx:smarturl' ?
                  NGX.App.result.link :
                  redirectUrl;
            }

            const additionalParams = buildAdditionalParams({
              title:       tokenizeMe(data.title, data),
              description: tokenizeMe(data.message, data),
              image:       canonSrc ? canonSrc : '',
              redirectUrl: redirectUrl,
            });
            const link = buildLink(linkUrl, false, additionalParams);

            NGX.App.api.facebookShare({
              name:        tokenizeMe(data.title, data),
              link:        link,
              picture:     canonSrc ? canonSrc : '',
              caption:     tokenizeMe(data.byline, data),
              description: tokenizeMe(data.message, data),
            });
            // API
            // Privacy management: analytics & insights tracking are gated there.
            if (data.context === 'campaign') {
              NGX.Analytics.trigger(PUB.ACTION_SHARE_CAMPAIGN_FACEBOOK);
            } else {
              NGX.Analytics.trigger(PUB.ACTION_SHARE_CONTENT_FACEBOOK);
            }
          }
          trackShare($.extend({}, data, { target: 'facebook' }));
        },
      },
      pinterest: {
        post: function(data, overrides) {
          _.extend(data, overrides);
          var pictureData = assetFromRef(data.picture, NGX.context),
            canonSrc = isAssetRef(data.picture) ? pictureData.src : data.picture;
          if (canonSrc) canonSrc = canonSrc.substring(0, 2) == '//' ? 'https:' + canonSrc : canonSrc;

          const url = 'pinterest.com/pin/create/button';
          const params = {
            media:       canonSrc ? canonSrc : '',
            url:         buildLink(data.link, overrides.linktype == 'internal'),
            description: tokenizeMe(data.message, data),
          };
          openWindow(url, params);

          // API
          // Privacy management: analytics & insights tracking are gated there.
          if (data.context === 'campaign') {
            NGX.Analytics.trigger(PUB.ACTION_SHARE_CAMPAIGN_PINTEREST);
          } else {
            NGX.Analytics.trigger(PUB.ACTION_SHARE_CONTENT_PINTEREST);
          }

          trackShare($.extend({}, data, { target: 'pinterest' }));
        },
      },
      weibo: {
        post: function(data, overrides) {
          _.extend(data, overrides);
          var pictureData = assetFromRef(data.picture, NGX.context),
            canonSrc = isAssetRef(data.picture) ? pictureData.src : data.picture;

          const url = 'http://service.weibo.com/share/share.php';
          const params = {
            url:   buildLink(data.link, overrides.linktype == 'internal'),
            title: tokenizeMe(data.message, data),
            pic:   canonSrc ? canonSrc : '',
          };
          openWindow(url, params);

          trackShare($.extend({}, data, { target: 'weibo' }));
        },
      },
    },
    shareFactory = function(obj) {
      // only build out JS for required modules
      if (obj.enabled === 'true' && networks[obj.network]) {
        // add to public API with a data property containing the sharing object (or use the existing one if it's there)
        NGX.App.api.share[obj.context] = NGX.App.api.share[obj.context] || { data: obj };
        // create data-bound function for sharing
        NGX.App.api.share[obj.context][obj.network] = networks[obj.network].post.bind(obj, obj.data[0]);
      }
    };

  var init = function() {
    // make sure the share section of the API is configured
    NGX.App.api.share = NGX.App.api.share || {};

    // expose methods to public API
    NGX.App.api.addShare = shareFactory;

    // create the dynamic API options
    NGX.App.Events.on('page:ready', function() {
      _.each(NGX.App.config.sharingConfig, function(item) {
        shareFactory(item);
      });
    });

    // show confirmation message // TODO: tidy this up a - will we be using other networks for confirmation?.
    var _confShare = function(force) {
      if (
        NGX.App.api.share &&
        NGX.App.api.share.confirmation &&
        ('confirmation' === NGX.App.state.name || force) &&
        'function' === typeof NGX.App.api.share.confirmation.facebook
      ) {
        NGX.App.api.share.confirmation.facebook({ context: 'confirmation' });
      }
    };

    NGX.App.Events.on('entry:success:spa', _confShare.bind(this, true));
  };

  return {
    init,
  };
})(window, document);
